<!--Information-->
<div>
	<div class="CenterText">
		<label class="WarningLabel"
			>School IDs <span style="color: red">CANNOT BE CHANGED</span> once the school is added. Please
			<span style="color: red">CHECK WITH DEVELOPMENT</span> that the School ID is correct then enter it below to confirm.</label
		>
	</div>

	<div class="TopMargin">
		<input type="text" class="form-control InputWidth" type="text" [(ngModel)]="SchoolID" />
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Confirm</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
